import { render, staticRenderFns } from "./SOVDetailedamdIndia.vue?vue&type=template&id=7a0e86c6&scoped=true"
import script from "./SOVDetailedamdIndia.vue?vue&type=script&lang=js"
export * from "./SOVDetailedamdIndia.vue?vue&type=script&lang=js"
import style0 from "./SOVDetailedamdIndia.vue?vue&type=style&index=0&id=7a0e86c6&prod&lang=css"
import style1 from "./SOVDetailedamdIndia.vue?vue&type=style&index=1&id=7a0e86c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0e86c6",
  null
  
)

export default component.exports